import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    // console.log(value);
    // return super.transform(value && value.split(".")[0], 'dd-MM-yyyy hh:mm a');
    return moment(value).format('DD-MM-YYYY hh:mm A');
  }
}


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/utilities/app.dateformat.pipe.ts